/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    Filter,
    List,
    SearchInput,
    ReferenceInput,
    AutocompleteInput,
    ReferenceField,
} from 'react-admin';
import AvisStatutInput from './inputs/AvisStatutInput';
import ActionField from './fields/ActionField'; // Import the ActionField
import FactureBoxroadStatusField from './fields/StatutField';
import { useRecordContext } from 'react-admin';
import { useTranslate } from 'react-admin';
import { NumberField } from 'react-admin';

const AvisFilter = (props: any) => (
    <Filter {...props}>
        {/* <SearchInput source="q" alwaysOn /> */}
        <AvisStatutInput
            source="status"
            label="resources.factures_boxroad.fields.status"
            alwaysOn
        />

        <ReferenceInput
            source="livreur"
            label="resources.factures_boxroad.fields.livreur"
            reference="livreurs"
            alwaysOn
        >
            <AutocompleteInput optionText="name" emptyText="Tout" resettable />
        </ReferenceInput>
    </Filter>
);

const AvisList = (props: any) => {
    return (
        <List
            {...props}
            filters={<AvisFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
            hasCreate={false}
            filter={{ expand: 'livreur' }}
        >
            <Datagrid optimized>
                <TextField
                    source="number"
                    label="resources.factures_boxroad.fields.number"
                />
                <DateField
                    source="date"
                    type="date"
                    label="resources.factures_boxroad.fields.date"
                />

                <ReferenceField
                    source="livreur._id"
                    reference="livreurs"
                    label="resources.factures_boxroad.fields.livreur"
                >
                    <TextField source="name" />
                </ReferenceField>

                <ReferenceField
                    source="course"
                    reference="courses"
                    label="resources.factures_boxroad.fields.course"
                >
                    <p>
                        #<TextField source="code" />
                    </p>
                </ReferenceField>

                <NumberField
                    source="price_ttc"
                    label="resources.factures_boxroad.fields.price_ttc"
                    options={{
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }}
                />

                <TextField
                    source="payment_info.transaction_number"
                    label="resources.factures_boxroad.fields.transaction_number"
                />
                <FactureBoxroadStatusField
                    source="status"
                    label="resources.courses.fields.statut"
                />

                <DateField
                    source="created_at"
                    type="date"
                    label="resources.courses.fields.created_at"
                    showTime
                    options={{
                        hourCycle: 'h23',
                    }}
                />
                <ActionField source="action" label="" />
            </Datagrid>
        </List>
    );
};

export default AvisList;
